<template>
  <div>
    <vs-popup :title="$t('CostAndFreight')" :active.sync="showModal">
      <form>
        <div class="vx-row mb-2 w-full mx-0 mb-8">
          <div
            class="vx-col lg:w-1/3 w-full p-0 my-0 mt-8 vx-row"
            style="justify-content: center"
            v-if="
              DataPackageCurrent.transportsFleetInfo &&
              changeTransportsFleetInfo
            "
          >
            <span class="mt-1">{{ $t("TransportFleets") }}</span>

            <span class="text-success mt-1">{{
              ` : ${DataPackageCurrent.transportsFleetInfo.name}`
            }}</span>
            <vs-button
              type="gradient"
              icon-pack="feather"
              icon="icon-edit"
              size="small"
              class="bg_l_blue mr-4"
              @click.prevent="
                changeTransportsFleetInfo = !changeTransportsFleetInfo
              "
            ></vs-button>
          </div>
          <div
            class="vx-row vx-col lg:w-1/3 w-full"
            style="justify-content: center"
            v-else
          >
            <div
              class="vx-col p-1"
              :class="
                DataPackageCurrent.transportsFleetInfo ? 'lg:w-5/6' : 'w-full'
              "
            >
              <label class="vs-select--label">{{
                $t("TransportFleets")
              }}</label>
              <v-select
                label="name"
                name="originWarehouse"
                :options="allTransportsFleet"
                v-model="model.transportFleetId"
                :reduce="(x) => x.id"
                dir="rtl"
              >
              </v-select>
            </div>
            <div class="lg:w-1/6 pt-6 mt-1">
              <vs-button
                radius
                v-if="DataPackageCurrent.transportsFleetInfo"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                size="medium"
                class="p-0 m-0 d-inline"
                @click.prevent="
                  changeTransportsFleetInfo = !changeTransportsFleetInfo
                "
              ></vs-button>
            </div>
          </div>

          <div
            class="vx-row mt-8 vx-col lg:w-1/3 w-full mx-1"
            v-if="DataPackageCurrent.cost && changeCost"
            style="justify-content: center"
          >
            <span class="mt-1">{{ $t("ShippingFee") }}</span>
            <span class="text-success mt-1">{{
              ` : ${Number(DataPackageCurrent.cost).toLocaleString()}`
            }}</span>
            <vs-button
              type="gradient"
              icon-pack="feather"
              icon="icon-edit"
              size="small"
              class="bg_l_blue mr-6"
              @click.prevent="changeCost = !changeCost"
            ></vs-button>
          </div>
          <div
            class="vx-row vx-col lg:w-1/3 w-full mx-1"
            style="justify-content: center"
            v-else
          >
            <div
              class="vx-col p-1"
              :class="DataPackageCurrent.cost ? 'lg:w-5/6' : 'w-full'"
            >
              <label class="vs-select--label">{{ $t("ShippingFee") }}</label>
              <vs-input name="user" v-model="cost" />
            </div>
            <div class="lg:w-1/6 pt-6 mt-1">
              <vs-button
                radius
                v-if="DataPackageCurrent.cost"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                size="medium"
                class="d-inline"
                @click.prevent="changeCost = !changeCost"
              ></vs-button>
            </div>
          </div>

          <div
            class="vx-row mt-8 lg:w-1/3 w-full p-0 m-0"
            style="justify-content: center"
            v-if="
              DataPackageCurrent.billOfLadingNumber && changebillOfLadingNumber
            "
          >
            <span class="mt-1">{{ $t("billOfLadingNumber") }}</span>
            <span class="text-success mt-1">{{
              ` : ${DataPackageCurrent.billOfLadingNumber}`
            }}</span>
            <vs-button
              type="gradient"
              icon-pack="feather"
              icon="icon-edit"
              size="small"
              class="bg_l_blue mr-6"
              @click.prevent="
                changebillOfLadingNumber = !changebillOfLadingNumber
              "
            ></vs-button>
          </div>
          <div
            class="vx-row vx-col lg:w-1/3 w-full mx-1"
            style="justify-content: center"
            v-else
          >
            <div
              class="vx-col p-1"
              :class="
                DataPackageCurrent.billOfLadingNumber ? 'lg:w-9/12' : 'w-full'
              "
            >
              <label class="vs-select--label">{{
                $t("billOfLadingNumber")
              }}</label>
              <vs-input name="user" v-model="model.billOfLadingNumber" />
            </div>
            <div class="lg:w-1/6 pt-6 mt-1">
              <vs-button
                radius
                v-if="DataPackageCurrent.billOfLadingNumber"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                size="medium"
                class="d-inline"
                @click.prevent="
                  changebillOfLadingNumber = !changebillOfLadingNumber
                "
              ></vs-button>
            </div>
          </div>
        </div>
        <span v-if="showErr" class="text-danger mt-8">
          <div v-if="!model.billOfLadingNumber">
            {{ `لطفا ${$t("billOfLadingNumber")} را وارد کنید.` }}
          </div>
        </span>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          v-has-permission="permission295"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
export default {
  name: "saleManagement_BasicDefinitions_SalesPartnerPlan_NewCreatePlan",
  props: {
    show: { default: false },
    DataPackageCurrent: "",
  },
  data() {
    return {
      permission295: "AssignTransportFleetToPackage",
      changeTransportsFleetInfo: true,
      changeCost: true,
      changebillOfLadingNumber: true,
      onOperatorChice: true,
      CostForTransfer: "",
      billOfLadingNumber: "",
      model: {},
      showErr: false,
      cost: 0,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapGetters({
      allTransportsFleet: "shipping/listWithTransportsFleet",
    }),
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
        this.model = {};
        this.changeTransportsFleetInfo = true;
        this.changeCost = true;
        this.changebillOfLadingNumber = true;
      },
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.fetchTransportsFleet();
        if (this.model.cost) {
          this.cost = this.model.cost;
        } else this.model.cost = 0;
      }
    },
    cost(value) {
      if (value) {
        this.model.cost = this.cost;
        var n = parseFloat(value.replace(/,/g, ""), 10);
        this.cost = n.toLocaleString();
        this.model.cost = this.cost.replace(/,/g, "");
      } else {
        this.cost = 0;
        this.model.cost = 0;
      }
    },
  },
  methods: {
    ...mapActions({
      fetchTransportsFleet: "shipping/fetchList",
      assignTransportsFleet_Cost: "shipping/assignTransportsFleet_Cost",
    }),
    submitForm() {
      if (
        this.DataPackageCurrent.transportsFleetInfo ||
        this.model.transportFleetId
      ) {
        this.model.packageId = this.DataPackageCurrent.id;
        if (!this.model.transportFleetId) {
          this.model.transportFleetId =
            this.DataPackageCurrent.transportsFleetInfo.id;
        }
        if (!this.model.cost) {
          this.model.cost = this.DataPackageCurrent.cost;
        }
        if (!this.model.billOfLadingNumber) {
          this.model.billOfLadingNumber =
            this.DataPackageCurrent.billOfLadingNumber;
        }

        this.assignTransportsFleet_Cost(this.model).then(() => {});
        setTimeout(() => {
          this.$emit("finish");
          this.changeTransportsFleetInfo = true;
          this.changeCost = true;
          this.changebillOfLadingNumber = true;
          this.model = {};
        }, 3000);
      } else this.showErr = true;
    },
  },
};
</script>
